import React, { lazy, useMemo } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import RouteElement from '@RootCommon/components/RouteElement'
// import ErrorHtml from '@RootCommon/components/ErrorBoundary/error'
import ErrorHtml0 from '@/pages/More'
const ErrorHtml = <ErrorHtml0 />
import config from './config'


const RouterMenu = lazy(() => import('@RootCommon/components/RouterMenu'))
const BUILD_ENV = process.env.BUILD_ENV
// 深度遍历路由配置
const deepLoopRoute = (routeConfig: RouteConfigVo[]) => routeConfig.map(route => (
  <Route
    key={route.path}
    path={route.path}
    element={<RouteElement {...{ ...route, pvPageType: 'shop', routes: routeConfig }} />}
  >
    {route?.children?.length ? deepLoopRoute(route.children) : <></>}
  </Route>
))

export default function () {
  const routConfig = useMemo(() => BUILD_ENV ? config : [{
    path: '/',
    label: '主菜单',
    component: lazy(() => new Promise(resolve => resolve({
      default: (() => <RouterMenu routes={config}></RouterMenu>) as never,
    }))),
  }, ...config], [config])

  return (
    <RecoilRoot>
      <Router>
        <Routes>
          {deepLoopRoute(routConfig)}
          <Route path="*" element={ErrorHtml} />
        </Routes>
      </Router>
    </RecoilRoot>
  )
}
